module.exports = __webpack_public_path__ + "media/images/flags/mk-31ba11ec4d4cdae74ebc0cbc1b768f44.svg";